import { MOBILE_CHART_IMAGE_DATA, RESEARCH_DATA } from "const/case-study/road-assistance-mobile-app-case-study";
import Image from "next/image";
import MarqueeHeading from "./common/MarqueeHeading";

const Research = () => (
  <div className="bg-black py-16 px-6 md:py-12 md:px-10 xl:py-32 xl:px-0">
    <div className="hidden md:block">
      <MarqueeHeading
        marqueeTitle={"RESEARCH"}
        paragraph="Using the survey of automobile users, we asked them a few questions regarding their experience when their vehicle breaks down in the middle of nowhere."
        smallTitle={"Research"}
      />
    </div>
    {/* for mobile */}
    <div className="block md:hidden pt-32 px-6">
      <h2 className="text-white font-bold text-5xl">
        <span className="font-gilroy">Research</span>
      </h2>
      <p className="text-white text-lg mt-10 mb-16">
        <span className="font-gilroy">
          Using the survey of automobile users, we asked them a few questions
          regarding their experience when their vehicle breaks down in the
          middle of nowhere.
        </span>
      </p>
    </div>
    <div className="px-6 md:p-0 md:mt-16 xl:px-48">
      {RESEARCH_DATA.map((value) => (
        <div key={value.title} className="mt-20 mb-12">
          <h3 className="flex items-center font-bold text-white font-gilroy text-3xl md:text-4xl">
            <div className="mr-4">
              <Image
                alt="star"
                className="fs-0 w-7 h-7 md:w-auto md:h-auto"
                height={35}
                loading="lazy"
                src="/assets/case-study/roaddy/blue-star.webp"
                width={35}
              />
            </div>
            <span>{value.title}</span>
          </h3>
          <div className="mt-12 border-0 flex ml-2 bg-gradient-roaddy-research-para">
            <div className="border-r-4 md:border-r-[10px] border-t-0 border-l-0 border-b-0 border-celtic-blue rounded-tr-lg rounded-br-lg"></div>
            <p className="text-white text-justify ml-6 md:ml-12 mb-0 py-12 text-lg md:text-2xl">
              <span className="font-gilroy">{value.detail}</span>
            </p>
          </div>
        </div>
      ))}
    </div>
    <div className="pt-8 px-6 pb-12 md:p-0 xl:pt-24 xl:px-48">
      <h3 className="font-bold text-white flex items-center text-3xl md:text-4xl">
        <div className="mr-4 w-7 h-7 md:w-auto md:h-auto">
          <Image
            alt="star"
            height={35}
            loading="lazy"
            src="/assets/case-study/roaddy/blue-star.webp"
            width={35}
          />
        </div>
        <span className="font-gilroy">Survey</span>
      </h3>
      <div className="hidden md:block">
        <div className="flex pb-4 mb-6">
          <div className="w-1/2 pr-4">
            <h4 className="font-bold text-white text-2xl md:mt-20 xl:mt-12">
              <span>Your Age ?</span>
            </h4>
            <div className="flex mt-4 items-center gap-6">
              <div className="w-1/2">
                <p className="text-white mb-4 flex items-center">
                  <span className="mr-4 rounded-full w-5 h-5 bg-celtic-blue"></span>
                  <span>16-25&nbsp;&#40;65%&#x29;</span>
                </p>
                <p className="text-white mb-4 flex items-center">
                  <span className="mr-4 rounded-full w-5 h-5 bg-[#ff8e1d]"></span>
                  <span>26-40&nbsp;&#40;28%&#x29;</span>
                </p>
                <p className="text-white mb-4 flex items-center">
                  <span className="mr-4 rounded-full w-5 h-5 bg-[#3d9f00]"></span>
                  <span>41-60&nbsp;&#40;7%&#x29;</span>
                </p>
              </div>
              <div className="md:w-28 md:h-28 xl:w-auto xl:h-auto">
                <Image
                  alt="chart"
                  className="fs-0"
                  height={150}
                  src="/assets/case-study/roaddy/desktop-chart-1.webp"
                  width={150}
                />
              </div>
            </div>
          </div>
          <div className="w-1/2">
            <h4 className="font-bold text-white text-2xl md:mt-20 xl:mt-12">
              <span>You Are ?</span>
            </h4>
            <div className="flex mt-4 items-center gap-4">
              <div className="md:w-3/5 xl:w-1/2">
                <p className="text-white mb-4 flex items-center">
                  <span className="mr-4 rounded-full w-5 h-5 bg-celtic-blue"></span>
                  <span>Working Professional&nbsp;&#40;50%&#x29;</span>
                </p>
                <p className="text-white mb-3 flex items-center">
                  <span className="mr-4 rounded-full w-5 h-5 bg-[#ff8e1d]"></span>
                  <span>Student&nbsp;&#40;40%&#x29;</span>
                </p>
                <p className="text-white mb-3 flex items-center">
                  <span className="mr-4 rounded-full w-5 h-5 bg-[#3d9f00]"></span>
                  <span>Housewife&nbsp;&#40;10%&#x29;</span>
                </p>
              </div>
              <div className="md:w-28 md:h-28 xl:w-auto xl:h-auto">
                <Image
                  alt="chart"
                  className="fs-0"
                  height={150}
                  src="/assets/case-study/roaddy/desktop-chart-2.webp"
                  width={150}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="flex pb-4 mb-6">
          <div className="w-1/2 pr-4">
            <h4 className="font-bold text-white text-2xl md:mt-20 xl:mt-12">
              <span>How often do you use your vehicle ?</span>
            </h4>
            <div className="flex mt-4 items-center gap-4">
              <div className="w-1/2">
                <p className="text-white mb-4 flex items-center">
                  <span
                    className={`mr-4 rounded-full w-5 h-5 bg-celtic-blue`}
                  ></span>
                  <span>Everyday&nbsp;&#40;90%&#x29;</span>
                </p>
                <p className="text-white mb-4 flex items-center">
                  <span className="mr-4 rounded-full w-5 h-5 bg-[#ff8e1d]"></span>
                  <span>0-2 times a week&nbsp;&#40;9%&#x29;</span>
                </p>
                <p className="text-white mb-4 flex items-center">
                  <span className="mr-4 rounded-full w-5 h-5 bg-[#3d9f00]"></span>
                  <span>Rarely&nbsp;&#40;1%&#x29;</span>
                </p>
              </div>
              <div className="md:w-28 md:h-28 xl:w-auto xl:h-auto">
                <Image
                  alt="chart"
                  className="fs-0"
                  height={150}
                  src="/assets/case-study/roaddy/desktop-chart-3.webp"
                  width={150}
                />
              </div>
            </div>
          </div>
          <div className="w-1/2">
            <h4 className="font-bold text-white text-2xl md:mt-20 xl:mt-12">
              <span>How often do you face such troubles?</span>
            </h4>
            <div className="flex mt-4 items-center gap-4 md:justify-between xl:justify-start">
              <div className="w-1/2">
                <p className="text-white mb-4 flex items-center">
                  <span className="mr-4 rounded-full w-5 h-5 bg-celtic-blue"></span>
                  <span>Often&nbsp;&#40;70%&#x29;</span>
                </p>
                <p className="text-white mb-4 flex items-center">
                  <span className="mr-4 rounded-full w-5 h-5 bg-[#ff8e1d]"></span>
                  <span>Sometimes&nbsp;&#40;30%&#x29;</span>
                </p>
              </div>
              <div className="md:w-28 md:h-28 xl:w-auto xl:h-auto">
                <Image
                  alt="chart"
                  className="fs-0"
                  height={150}
                  src="/assets/case-study/roaddy/desktop-chart-4.webp"
                  width={150}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="hidden md:flex">
          <div className="w-1/2 pr-4">
            <h4 className="font-bold text-white pt-6 mb-12 text-2xl md:mt-20 xl:mt-12">
              <span>Issues faced while commuting</span>
            </h4>
            <Image
              alt="chart"
              height={454}
              src="/assets/case-study/roaddy/desktop-chart-5.webp"
              width={692}
            />
          </div>
          <div className="w-1/2 pl-4">
            <h4 className="font-bold text-white pt-6 mb-12 text-2xl md:mt-20 xl:mt-12">
              <span>Features desirable by users</span>
            </h4>
            <Image
              alt="chart"
              height={454}
              src="/assets/case-study/roaddy/desktop-chart-6.webp"
              width={692}
            />
          </div>
        </div>
      </div>
      {/* for mobile */}
      {MOBILE_CHART_IMAGE_DATA.map((value) => (
        <div key={value.id} className="block md:hidden w-full mt-12 pt-6">
          <Image
            key={value}
            alt="chart"
            src={value.src}
            width={value.width}
            height={value.height}
          />
        </div>
      ))}
    </div>
  </div>
);
export default Research;
